/** Payment API preserves PascalCase on the deployed compatibility host. */
export function normalizePaymentResponse(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return value;
  const result = Object.fromEntries(Object.entries(value).map(([key, item]) => [key[0].toLowerCase() + key.slice(1), item]));
  if (Array.isArray(result.data)) result.data = result.data.map(normalizePaymentResponse);
  return result;
}
